<div class="store">
    <div class="image-wrapper">
        <div class="image">
            <ng-container *ngIf="store.storePhotos as photos">
                <app-image *ngIf="photos[0]" [image]="photos[0]" [height]="64" [width]="64"></app-image>
                <app-svg-icon *ngIf="!photos[0]" iconName="favicon"></app-svg-icon>
            </ng-container>
        </div>
    </div>

    <section>
        <div class="header">
            <h4 class="display-6 store-name" [ngClass]="{ favorite: isFavorite }">{{ store.storeName }}</h4>

            @if ((!store.reserveInStore) && (type === 'reserve-in-basket' || type === 'reserve')) {
                <app-tooltip type="warning">
                    {{ 'reservation.tooltip.storeReservationNotAllowed' | translateSafe }}
                </app-tooltip>
            }
        </div>
        <div class="content">
            <div class="store-info">
                <div class="description">
                    <span>{{ store.address }}</span>
                    <span>{{ store.postalCode }} {{ store.city }}</span>
                </div>

                <div class="data">
                    <div class="schedule" *ngIf="type === 'select' && store.openingTimes as openingTimes">
                        <ng-container *ngIf="openingTimes[0] && !openingTimes[0].isClosed">
                            {{
                                'stores.labels.openTodayUntil'
                                    | translateSafe
                                    | formatString
                                    : { closeTime: (openingTimes[0].openToDateTime | date: 'HH.mm') || '' }
                            }}
                        </ng-container>
                        <ng-container *ngIf="openingTimes[0].isClosed">
                            {{ 'stores.labels.closedToday' | translateSafe }}
                        </ng-container>
                    </div>

                    @if (product && (type === 'reserve-in-basket' || type === 'reserve' || type === 'stock-status')) {
                        <div class="stock-status">
                            <app-store-stock-detailed
                                *ngIf="product.storeStocks as stocks"
                                [productStocks]="stocks"
                                [store]="store"
                            ></app-store-stock-detailed>
                        </div>
                    }
                </div>
            </div>

            @if (!isFavorite) {
                @if (type === 'select' || type === 'stock-status') {
                    <button class="kk-btn store-button" (click)="handleClick.emit()" *ngIf="!isFavorite">
                        {{ 'stock.buttons.chooseStore' | translateSafe }}
                    </button>
                }
            } @else {
                @if (type === 'select' || type === 'stock-status') {
                    <button class="chosen-store-text display-body" (click)="handleClick.emit()">
                        {{ 'stock.buttons.chosenStore' | translateSafe }}
                        <app-svg-icon iconName="tick"></app-svg-icon>
                    </button>
                }
            }
            <ng-container *ngTemplateOutlet="reserve"></ng-container>
        </div>
    </section>
</div>

<ng-template #reserve>
    @if (type === 'reserve' || type === 'reserve-in-basket') {
        <button class="kk-btn store-button" (click)="handleClick.emit()" [disabled]="!store.reserveInStore">
            {{ 'stock.buttons.reserve' | translateSafe }}
        </button>
    }
</ng-template>
